import { Component, Injector, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { BaseComponent } from 'src/app/common/base/base.component';
import { TransactionLogService } from 'src/app/services/logs/transaction-log.service';
import { TransactionLog } from 'src/app/services/logs/transaction-logs';

@Component({
  selector: 'checklist-builder-log',
  templateUrl: './checklist-builder-log.component.html',
  styleUrls: ['./checklist-builder-log.component.scss']
})
export class ChecklistBuilderLogComponent extends BaseComponent implements OnChanges, OnDestroy {

  @Input() serialNo?: string;
  @Input() expandedLog?: boolean;

  sortDown?: boolean;

  transactionLogs?: TransactionLog[];
  transactionLogsFiltered?: TransactionLog[];
  transactionLogsSubs!: Subscription;

  comments?: string = '';

  constructor(
    protected override injector: Injector,
    private service: TransactionLogService
  ) {
    super(injector);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadTransactionLogs();
  }

  override ngOnDestroy(): void {
    this.transactionLogsSubs?.unsubscribe();
    super.ngOnDestroy();
  }

  loadTransactionLogs() {
    this.transactionLogsSubs = this.store.select(state => state.TransactionLog.data).subscribe(data => {
      if (data?.length) {
        this.transactionLogs = data;
        this.transactionLogsFiltered = data.filter((l: TransactionLog) => l.serialNo == this.serialNo);
        this.transactionLogsFiltered?.forEach(l => {
          l.createdByInitials = this.users.find(u => u.id == l.createdBy)?.initials;
          l.createdByName = this.users.find(u => u.id == l.createdBy)?.name;
          l.description = l.description?.replaceAll('<br>', '');
          l.description = l.description?.replaceAll(' ⇒ ', '<hr>');
          if (l.name === 'WFTaskLocal - Delete') l.name = 'Delete Task';
          this.sort();
        });
      }
    });
  }

  goto(code?: string) {
    if (!code) return;
    setTimeout(() => {
      const el = document.getElementById(code);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  }

  sort() {
    if (this.sortDown)
      this.transactionLogsFiltered?.sort((a, b) => this.utils.sort(a.createdOn, b.createdOn));
    else
      this.transactionLogsFiltered?.sort((a, b) => this.utils.sort(b.createdOn, a.createdOn));
  }

  save(log: TransactionLog) {
    if (log.id) {
      this.service.UpdateComments(log.id, log.objectJson || '').subscribe(() => {
        // Handle success if needed
      });
    }
  }
}
